<template>
  <v-flex
    id="warehouseManager"
    class="question"
  >
    <h2 class="header">
      {{ $t('warehouses.warehouse_manager.title') }}
    </h2>
    <ul class="questions-list">
      <li class="mt-4">
        <p class="header required">
          {{ $t('warehouses.warehouse_manager.question_1') }}
        </p>
        <v-autocomplete
          v-model="manager"
          v-validate="validationRules.get('warehouseManager')"
          :placeholder="$t('warehouses.supporting_warehouse_manager.name_placeholder')"
          append-icon="expand_more"
          :error-messages="errors.collect('manager')"
          :data-vv-as="' '"
          data-vv-name="manager"
          :items="managerList"
          item-text="full_name"
          item-value="id"
        />
      </li>
      <li
        v-if="manager !== null"
        class="mt-4"
      >
        <p class="header required custom lA">
          {{ $t('warehouses.supporting_warehouse_manager.question_1a') }}
        </p>
        <p class="fw-400 f-14 sz_dark_grey--text mb-0">
          {{ $t('warehouses.warehouse_manager.info') }}
        </p>
        <v-flex md5>
          <v-text-field
            v-model="phone"
            v-validate="validationRules.get('phone')"
            :mask="phoneMask(phone)"
            :placeholder="$t('warehouses.warehouse_manager.placeholder_1b')"
            :error-messages="errors.collect('phone')"
            :data-vv-as="' '"
            data-vv-name="phone"
            required
            type="tel"
            inputmode="tel"
          />
        </v-flex>
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';
import phoneMask from '@/utils/phoneMask';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'warehouses/getSupportingWarehouseManagerField',
    mutationType: 'warehouses/updateSupportingWarehouseManagerField'
});

export default {
    name: 'SupportingWarehouseManager',
    inject: ['$validator'],
    data () {
        return {
            validationRules,
            phoneMask
        };
    },
    computed: {
        ...mapFields(['manager', 'phone', 'full_name']),
        managerList () {
            return this.$store.getters['warehouses/getWarehouseManagers'];
        }
    },
    watch: {
        manager: {
            handler (val) {
                const _manager = this.managerList.find((el) => el.id === val);
                if (_manager) {
                    this.full_name = _manager.full_name;
                    this.phone = _manager.phone;
                }
            }
        },
        managerList: {
            handler (val) {
                if (val.length === 1) {
                    this.manager = val[0].id;
                }
                if (this.manager != null && !val.find((el) => el.id === this.manager)) {
                    this.manager = null;
                    this.phone = null;
                    this.full_name = null;
                }
            }
        }
    },
    beforeCreate () {
        const data = {
            wioStructId: this.$store.getters['warehouses/getSelectedProvince'].province_id,
            warehouseType: 'supporting'
        };
        this.$store.dispatch('warehouses/getWarehouseManagers', data);
    }
};
</script>

<style scoped></style>
